export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = false
export const ENABLE_MIGRATE_STATS = false
export const BLOWFISH_KEY = 'sughusik#Thq&LG*8es2DsZ$3bw^e'
export const BLOWFISH_IV = '#4XmF^ws'
export const LEADERBOARD_MIN_RESULTS = 8
export const HARDEST_WORD_LOOKBACK_DAYS = 10
export const TIME_BUCKET_SECONDS = 15
export const TIME_MIN_SECONDS = 15
export const TIME_MAX_SECONDS = 240

// Baseline guess distribution used before a day has enough real results.
// Weights (out of 1000) for solving in 1..6 guesses, then failures.
export const GLOBAL_GUESS_DISTRIBUTION = [5, 40, 200, 330, 250, 120]
export const GLOBAL_FAILED = 55
